module.exports = __webpack_public_path__ + "r-v3/img/grm-face-01.1c431669.svg";